import {createSelector} from 'reselect';
import ContractlistState, {ListContract} from "./ContractlistState";

const stateFetchingContracts = (state: ContractlistState) => state.fetchingContracts;
export const stateContracts = (state: ContractlistState) => state.contracts;
const statePage = (state: ContractlistState) => state.page;
export const stateSearchString = (state: ContractlistState) => state.searchString;
const stateTypeFilter = (state: ContractlistState) => state.typeFilter;
const stateShowOtherPeoplesContracts = (state: ContractlistState) => state.showOtherPeoplesContracts;
const stateCurrentUser = (state: ContractlistState) => state.currentUser;
const stateSortField = (state: ContractlistState) => state.sortByField;
const stateSortAscending = (state: ContractlistState) => state.isAscending;
const stateArchivedFilter = (state: ContractlistState) => state.showArchivedContracts;
const stateHasChanges = (state: ContractlistState) => state.contractsWithChangeIndicator;
const stateTotalNumberOfContractsWithCurrentFilter = (state: ContractlistState) => state.totalNumberOfContractsWithCurrentFilter;

export const page = createSelector(
    [statePage], (page) => {
        return page;
    }
);

export const totalNumberOfContractsWithCurrentFilter = createSelector(
    [stateTotalNumberOfContractsWithCurrentFilter], (totalNumberOfContractsWithCurrentFilter) => {
        return totalNumberOfContractsWithCurrentFilter;
    }
);

export const currentUser = createSelector(
    [stateCurrentUser], (user) => {
        return user;
    }
);

export const showOtherPeoplesContracts = createSelector(
    [stateShowOtherPeoplesContracts], (showOtherPeoplesContracts) => {
        return showOtherPeoplesContracts;
    }
);


export const hasCreatePermission = createSelector(
    [stateCurrentUser], (currentUser) => {
        return currentUser?.hasPermissionInAnyScope("CONTRACT", "CREATE");
    }
);

export const typeFilter = createSelector(
    [stateTypeFilter], (typeFilter) => {
        return typeFilter;
    }
);

export const sortByField = createSelector(
    [stateSortField], (sortByField) => {
        return sortByField;
    }
);

export const isAscending = createSelector(
    [stateSortAscending], (isAscending) => {
        return isAscending;
    }
);

export const showArchivedContracts = createSelector(
    [stateArchivedFilter], (showArchivedContracts) => {
        return showArchivedContracts;
    }
);

const sortedContracts = createSelector(
    [stateContracts], (contracts: ListContract[]) => {
        return contracts;
    }
);

export const paginatedContracts = createSelector(
    [sortedContracts, page],
    (contracts, page) => {
        return contracts.slice(0, page * 50);
    }
);

export const contractsWithArchivePermission = createSelector(
    [paginatedContracts, stateCurrentUser], (contracts: ListContract[], currentUser) => {
        if (!currentUser) return contracts;
        return contracts.map(contract => {
            // Vi overstyrer permissions i samsvar med logikk på backend
            // Se NVDB-5645
            contract.canArchive =
                currentUser.hasPermission('CONTRACT:ARCHIVE', contract.id)
                && (
                    contract.assignee === currentUser.username
                    || currentUser.globalAdmin
                    || currentUser.isGroupAdmin(contract.contractGroup)
                )
            return contract;
        })
    }
);

export const contractsWithDeletePermission = createSelector(
    [contractsWithArchivePermission, stateCurrentUser], (contracts: ListContract[], currentUser) => {
        if (!currentUser) return contracts;
        return contracts.map(contract => {
            // Vi overstyrer permissions i samsvar med logikk på backend
            // Se NVDB-5645
            contract.canDelete = currentUser.hasPermission('CONTRACT:DELETE', contract.id)
                && (
                    contract.assignee === currentUser.username
                    || currentUser.globalAdmin
                )
            return contract;
        })
    }
);

export const contractsWithChangeIndicator = createSelector(
    [contractsWithDeletePermission, stateHasChanges], (contracts, hasChanges) => {
        return contracts.map(contract => {
            contract.hasChanges = hasChanges[contract.id];
            return contract;
        })
    }
);

export const contracts = createSelector(
    [contractsWithChangeIndicator],
    (contracts) => {
        return contracts;
    }
);

export const getContractsCheckedForChanges = createSelector(
    [stateHasChanges], (hasChanges) => {
        return Object.keys(hasChanges);
    }
)

export const numberOfDisplayedHits = createSelector(
    [contracts], (contracts) => {
        return contracts.length;
    }
);

export const fetchingContracts = createSelector(
    [stateFetchingContracts],
    (fetchingContracts) => {
        return fetchingContracts;
    }
);









